import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Check, Search, Package, X } from "lucide-react";

// Select materials consumed on site + quantity. NO cost is ever shown to field workers.
// value = [{ material_id, product_name, unit, quantity }]
export default function MaterialsUsedPicker({ value, onChange }) {
  const selected = value || [];
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/materials?include_inactive=false").then((r) => setItems(r.data)).catch(() => {}); }, []);

  const isSel = (id) => selected.some((s) => s.material_id === id);
  const toggle = (it) => {
    if (isSel(it.id)) onChange(selected.filter((s) => s.material_id !== it.id));
    else onChange([...selected, { material_id: it.id, product_name: it.product_name, unit: it.unit, quantity: "" }]);
  };
  const setQty = (id, val) => onChange(selected.map((s) => (s.material_id === id ? { ...s, quantity: val } : s)));
  const matches = q ? items.filter((it) => `${it.product_name} ${it.supplier}`.toLowerCase().includes(q.toLowerCase())) : items;

  return (
    <div data-testid="materials-used-picker">
      {selected.length > 0 && (
        <div className="space-y-1.5 mb-2" data-testid="materials-used-selected">
          {selected.map((s) => (
            <div key={s.material_id} className="flex items-center gap-2 bg-navy/5 border border-navy/10 rounded-lg px-2.5 py-1.5">
              <Package className="w-3.5 h-3.5 text-navy shrink-0" />
              <span className="flex-1 text-sm text-navy truncate">{s.product_name}</span>
              <input data-testid={`material-qty-${s.material_id}`} type="number" min="0" step="any" value={s.quantity}
                onChange={(e) => setQty(s.material_id, e.target.value)} placeholder="Qty"
                className="w-16 text-sm border border-slate-200 rounded-md px-2 py-1 text-right outline-none focus:border-navy" />
              <span className="text-xs text-slate-400 w-14 truncate">{s.unit}</span>
              <button type="button" onClick={() => toggle({ id: s.material_id })} className="text-slate-400 hover:text-red-500"><X className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
      )}
      <div className="relative">
        <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
        <input data-testid="materials-used-search" value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Search materials…" className="w-full border border-slate-200 rounded-lg pl-9 pr-3 py-2 text-sm outline-none focus:border-navy" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 mt-2 max-h-56 overflow-y-auto">
        {matches.map((it) => (
          <button key={it.id} type="button" data-testid={`material-option-${it.id}`} onClick={() => toggle(it)}
            className={`flex items-center gap-2 px-2.5 py-2 rounded-lg border text-sm text-left transition-colors ${isSel(it.id) ? "border-navy bg-navy/5" : "border-slate-200 hover:bg-slate-50"}`}>
            <span className="flex-1 min-w-0">
              <span className="block truncate text-navy">{it.product_name}</span>
              {it.supplier && <span className="block truncate text-[11px] text-slate-400">{it.supplier}</span>}
            </span>
            <span className="text-[10px] uppercase tracking-wide text-slate-400 shrink-0">{it.unit}</span>
            {isSel(it.id) && <Check className="w-4 h-4 text-navy shrink-0" />}
          </button>
        ))}
        {matches.length === 0 && <p className="col-span-full text-sm text-slate-400 px-1 py-2">No materials found. Add them under Settings → Materials.</p>}
      </div>
    </div>
  );
}
